import React from 'react';
import PropTypes from 'prop-types';
import EmbeddedSectionStyles from './EmbeddedSection.styled';
import { extractColors } from '@utils/utils';
import WistiaVideoEmbed from '@components/Shared/WistiaVideoEmbed/WistiaVideoEmbed';
import Markdown from '../Markdown/Markdown';
import { slugify } from '@utils/studioUtils';
import { useEffect, useState } from 'react';

const EmbeddedSection = ({ section }) => {
  const [displayVideo, setDisplayVideo] = useState(false);

  useEffect(() => setDisplayVideo(true), []);
  return (
    <EmbeddedSectionStyles
      $bgColor={extractColors(section?.embeddedContentBgColor)}
      id={slugify(section?.embeddedContentHeader)}
    >
      <div className="embedded-content-container">
        <h1 className="embedded-content-header">
          {section?.embeddedContentHeader}
        </h1>
        <p className="embedded-content-subheader">
          {section?.embeddedContentSubHeader}
        </p>
        <div className="embedded-content-video">
          {section?.embeddedContent && displayVideo ? (
            <WistiaVideoEmbed wistiaID={section?.embeddedContent} altText="" />
          ) : (
            <></>
          )}
        </div>
        <p>
          <Markdown markdown={section?.embeddedContentLongIntro}></Markdown>
        </p>
      </div>
    </EmbeddedSectionStyles>
  );
};

export default EmbeddedSection;

EmbeddedSection.propTypes = {
  section: PropTypes.object,
};
